import { WidgetBlockToViewBlockHoC, WidgetBlockWrapper } from '../../state-management';
import IWidgetBlock from '../types/IWidgetBlock';
import defaultState from './defaultState';
import reducer from './reducer';
import { WarningBoxConfigBlockState, WarningBoxState } from './types';
import WarningBox from './WarningBox';
import WidgetConfigurator from './WidgetConfigurator/WidgetConfigurator';

const WidgetModel: IWidgetBlock<WarningBoxConfigBlockState, WarningBoxState> = {
    label: 'Warning Box',
    type: 'warningBox',
    dataStructures: ['timeseries/point2d'],
    mimeTypes: ['application/vnd.metocean.cf+json'],
    defaultState,
    reducer,
    widgetBlock: WidgetBlockWrapper(WarningBox),
    render: WidgetBlockToViewBlockHoC(reducer, WarningBox),
    widgetConfigurator: WidgetConfigurator,
    widgetComponent: WarningBox,
};

export default WidgetModel;
